import React, {Component} from 'react';
import {  Link } from 'react-router-dom';
import axios from 'axios';
import HomeZone from './models/HomeZone';
import {v4 as uuidv4} from 'uuid';
// const querystring = require('querystring');
export default class CreateHomeZone extends Component {

	constructor(props)
	{
		console.log(props);
		super(props);
		let parms = "";
// 		JSON.stringify(querystring.parse(this.props.location.search)).replace('?', '');
//         console.log("parms => " + parms);
		this.state={
			homeZone : HomeZone,
			identityPrincipal : ""
		}
		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleOnLoad = this.handleOnLoad.bind(this);
		
		
	}
	handleChange(event) {
		console.log(event);
		var target = event.target;
		console.log(target.id + ":" + target.value);
		this.setState({homeZone : {...this.state.homeZone, [target.id] : target.value} });
	   
		console.log(this.state);
	  }
	handleSubmit(event) {

		event.preventDefault();
		console.log('handling submit');  
	
// 		var idUrl = `${global.config.securityServicesUrl}/next-id-generator/get-next/homeZones/homeZoneId`;
	  	var url = `${global.config.dataServicesUrl}/gazelle/HomeZones`;

//   		axios.get(idUrl).then(response => {
// 		  	this.setState({homeZone : {...this.state.homeZone, homeZoneId : response.data["nextId"]}});
// 	  
// 			console.log("new homeZone id = " + JSON.stringify(this.state.homeZone.homeZoneId));
// 	
		let idp = this.state.identityPrincipal;
		console.log('identity ' + idp + ":" + this.state.identityPrincipal);
		HomeZone.id = uuidv4();
		HomeZone.identityPrincipal = idp;
		HomeZone.createUser = HomeZone.lastUpdateUser = idp;
		HomeZone.createDate = HomeZone.lastUpdateDate = new Date();
		HomeZone.name = this.state.homeZone.name;
		HomeZone.description = this.state.homeZone.description;
		HomeZone.notes = this.state.homeZone.notes;
		
		console.log('b4 setState -> ' + JSON.stringify(HomeZone));
		this.state.homeZone = HomeZone;
// 		this.setState({homeZone : HomeZone});
		// this.setState({homeZone : {...this.state.homeZone, createUser : idp }});
// 		this.setState({homeZone : {...this.state.homeZone, lastUpdateUser : idp }});
// 		this.setState({homeZone : {...this.state.homeZone, createDate : new Date() }});
// 		this.setState({homeZone : {...this.state.homeZone, lastUpdateDate : new Date() }});
			console.log('saving state.homeZone => ' + JSON.stringify(this.state.homeZone));
			
			axios.post(url, this.state.homeZone).then(response2 => {
				console.log("response.data");
				console.log(response2.status +":"+response2.data);
				if (response2.status === 200 )
				{
					this.message = "Success";
					//this.handleClear();	
				}
				else
				{
					 this.message = "Failed";
				}        
				console.log(this.message);
		  	}).catch(err => {
				console.log("error - " + err);
		  	});
		  //});
		console.log("message info - " + this.message); 
		window.location.href = '/vlm-home';
		//		
	 };
	 handleClear(){
		 this.setState({homeZone : HomeZone})
	 }
	 componentDidMount() 
	 {
	 	this.handleClear();
	 	
	 	var queryUrl = `${global.config.securityServicesUrl}/user-profile-service/email/${this.props.userId}`;
 		console.log('up url = ' + queryUrl);
		axios.get(queryUrl).then(response => {
// 				const currentUserProfileData = response.data; 
			console.log('setting idp - ' + response.data);
				this.setState({identityPrincipal : response.data});	
			console.log('set idp - ' + JSON.stringify(this.state));
			}).catch(function (error){
				console.log(error);
		});	

	 }

	handleOnLoad = () => {
//		this.handleClear();
		
// 		var queryUrl = `${global.config.securityServicesUrl}/user-profile-service/userprofile/${this.props.userId}`;
// 		console.log(queryUrl);
// 		axios.get(queryUrl)
// 		 	.then(response => {
// 			const currentUserProfileData = response.data; 
// 			console.log('updata -> ' + JSON.stringify(currentUserProfileData));
// 			this.setState({currentUserProfile : currentUserProfileData});	
// 			});
	}
	
	render(){
    return (
        	<div class="m-content">				
			<div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">
       				<div class="m-grid__item m-grid__item--fluid m-wrapper">
					<div class="m-subheader ">					
						<div class="d-flex align-items-center">
							<div class="mr-auto">
								<h3 class="m-subheader__title m-subheader__title--separator">Gazelle VLM</h3>
								<ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
									<li class="m-nav__item m-nav__item--home">
										<Link to="/" class="m-nav__link m-nav__link--icon">
											<i class="m-nav__link-icon la la-home"></i>
										</Link>
									</li>
									<li class="m-nav__separator">-</li>
									<li class="m-nav__item">
										<Link to="/" class="m-nav__link">
											<span class="m-nav__link-text">Home</span>
										</Link>
									</li>
								</ul>
							</div>
							<div>
								<span class="m-subheader__daterange" id="m_dashboard_daterangepicker">
									<span class="m-subheader__daterange-label">
										<span class="m-subheader__daterange-title"></span>
										<span class="m-subheader__daterange-date m--font-brand"></span>
									</span>
									<a href="#" class="btn btn-sm btn-brand m-btn m-btn--icon m-btn--icon-only m-btn--custom m-btn--pill">
										<i class="la la-angle-down"></i>
									</a>
								</span>
							</div>
						</div>
						<br />

					<div className="content-wrapper">
		
		<form>
		<div class="container-fluid">
		<h4>Create Zone</h4>
		<hr />
		

		<div class="form-group row" >
		<label class="ContentTitle col-sm-2" >Name</label>
		<input id="name" class="form-control input-medium col-sm-8" value={this.state.homeZone.name} onChange ={this.handleChange}/>
		</div>
			<div class="form-group row" >
		<label class="ContentTitle col-sm-2" >Description</label>
		<input id="description" class="form-control input-medium col-sm-8" value={this.state.homeZone.description} onChange ={this.handleChange} /> 
		</div>

		<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Notes</label>
			<textarea id="notes" class="form-control input-medium col-sm-8" value={this.state.homeZone.notes} onChange ={this.handleChange}>				
			</textarea>
		</div>
		
		<hr />					
					<button class="btn btn-primary" value="Clear" onClick ={this.handleClear}>Clear</button> &nbsp;
					<button class="btn btn-success" value="Create" onClick ={this.handleSubmit}>Save</button>&nbsp;
		</div>		
		</form>
						</div>		

	            </div>	
            </div>
            
			</div>
			</div>
	);
}
}